import React from 'react';
import { Target, Brain, Users, Crosshair, Dumbbell, Zap } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function Metodo() {
  const beneficios = [{
    icon: Target,
    title: 'Técnica'
  }, {
    icon: Brain,
    title: 'Táctica'
  }, {
    icon: Users,
    title: 'Dobles'
  }, {
    icon: Crosshair,
    title: 'Posicionamiento'
  }, {
    icon: Zap,
    title: 'Mentalidad'
  }, {
    icon: Dumbbell,
    title: 'Entrenamiento'
  }];
  return <section className="py-14 bg-court-gradient relative border-t border-white/5" data-id="element-136">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-137">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-138">
          <FadeIn data-id="element-139">
            <h2 className="font-display text-3xl md:text-4xl font-bold mb-4 uppercase" data-id="element-140">
              Presentamos <span className="text-neon" data-id="element-141">PÁDEL MASTER PACK</span>
            </h2>
            <p className="text-lg text-gray-300" data-id="element-142">
              Un sistema completo diseñado para ayudarte a mejorar cada aspecto
              de tu juego paso a paso.
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-143">
          {beneficios.map((ben, idx) => <FadeIn key={idx} delay={idx * 0.08} direction="up" data-id="element-144">
              <div className="bg-padel-dark border border-white/10 p-5 rounded-xl flex flex-col items-center text-center hover:border-neon/50 transition-colors group" data-id="element-145">
                <div className="bg-white/5 p-3 rounded-full mb-3 group-hover:bg-neon/10 group-hover:text-neon transition-colors" data-id="element-146">
                  <ben.icon className="w-7 h-7" data-id="element-147" />
                </div>
                <h3 className="font-display text-lg font-bold uppercase tracking-wide" data-id="element-148">
                  {ben.title}
                </h3>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}